import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { UserCard } from '../../components';

import css from './ProjectListingPage.css';

const SectionHostMaybe = props => {
  const { listing, onContactUser, currentUser } = props;

  if (!listing.author) {
    return null;
  }

  return (
    <div id="host" className={css.sectionHost}>
      <h2 className={css.yourHostHeading}>
        <FormattedMessage id="ProjectListingPage.yourCustomerHeading" />
      </h2>
      <UserCard user={listing.author} currentUser={currentUser} onContactUser={onContactUser} />
    </div>
  );
};

export default SectionHostMaybe;
